import { TRootState } from '../reducers';
import { ILayoutState } from './types';

export const layoutSelector = (state: TRootState): ILayoutState => state.layout;
export const cartLayoutSelector = (state: TRootState): boolean => state.layout.cart;
export const menuLayoutSelector = (state: TRootState): boolean => state.layout.menu;
export const searchLayoutSelector = (state: TRootState): string => state.layout.search;
export const notFoundLayoutSelector = (state: TRootState): boolean => state.layout.isNotFound;
export const addressModalLayoutSelector = (state: TRootState): boolean => state.layout.isAddressModalOpen;
